<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <form class="form-horizontal">
                    <div class="form-group">
                        <div class="col-sm-3">
                            <select
                                v-model="perPage"
                                class="form-control"
                                id="perPageSelect"
                            >
                                <option
                                    v-for="pageOption in pageOptions"
                                    :value="pageOption"
                                >
                                    {{ pageOption }}
                                </option>
                            </select>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-6">
                <b-pagination
                    class="pull-right margin"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    align="right"
                ></b-pagination>
            </div>
        </div>
        <b-table
            :filter="searchQuery"
            ref="ordersTable"
            sort-icon-left
            :sort-desc="true"
            sort-by="Orders.completed"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :responsive="true"
            bordered
            :items="orderProvider"
        >
            <template v-slot:HEAD_bulk="data">
                <b-form-checkbox
                    @change="selectAll"
                    name="select-all">
                </b-form-checkbox>
            </template>
            <template v-slot:bulk="{item}">
                <b-form-checkbox
                    :id="`order-${item['Orders.id']}`"
                    v-model="internallySelected"
                    :name="`order-${item['Orders.id']}`"
                    @change="clicked"
                    :value="item['Orders.id']"
                    :unchecked-value="item['Orders.id']">
                </b-form-checkbox>
            </template>
            <template v-slot:Orders.id="{item}">
                #{{ item[`Orders.id`] }}
            </template>
            <template v-slot:Orders.order_status="{item}">
                <order-status-label
                    :order-status='(item[`Orders.order_status`])'
                ></order-status-label>
            </template>
            <template v-slot:action="{item}">
                <a
                    class="btn btn-xs btn-success"
                    target="_blank"
                    :href="`/${$root.state.loggedInUser.role}/orders/view/${item['Orders.id']}`"
                >
                    View
                </a>
                <div
                    v-if="item[`Orders.order_status`] === `complete`"
                    class="btn-group dropup"
                >
                    <button
                        type="button"
                        data-toggle="dropdown"
                        class="btn btn-default btn-xs dropdown-toggle"
                        aria-expanded="false"
                    >
                        Mark processed<span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right">
                        <li>
                            <api-post-button
                                confirm="Are you sure you want to mark this order as processed and notify the customer?"
                                :end-point="`/api/v0/orders/mark_processed/${item['Orders.id']}`"
                                method="put"
                                :params="{notify_customer: true}"
                                :config="{headers: {token: $root.state.api_token}}"
                                @response="refreshTable"
                                text="Send notification"
                                tag="a"
                            ></api-post-button>
                        </li>
                        <li>
                            <api-post-button
                                confirm="Are you sure you want to mark this order as processed and not notify the customer?"
                                :end-point="`/api/v0/orders/mark_processed/${item['Orders.id']}`"
                                method="put"
                                :params="{notify_customer: false}"
                                :config="{headers: {token: $root.state.api_token}}"
                                @response="refreshTable"
                                text="No notification"
                                tag="a"
                            ></api-post-button>
                        </li>
                    </ul>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import ApiPostButton from "../Utility/Buttons/ApiPostButton.vue";
import OrderStatusLabel from "./OrderStatusLabel.vue";

export default {
    components: {
        ApiPostButton,
        OrderStatusLabel
    },

    props: {
        searchQuery: {
            type: String
        },
        reportKey: {
            type: String,
            default: "",
            required: false
        },
        value: { //v-model for selected ID's
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            fields: [], // basic default fields for front end
            loading: false,
            perPage: 50,
            currentPage: 1,
            pageOptions: [50, 100, 150, 200],
            rows: 0,
            query: '',
            internallySelected: [],
            inViewIds: [], //the list of ID's currently on display to the user - used for selecting all checkboxes
        }
    },
    watch: {
        value: {
            handler(val) {
                this.internallySelected = val
            },
            immediate: true
        },
        inViewIds() {
            this.$emit('updated', {inViewIds: this.inViewIds, rows: this.rows});
        },
        perPage() {
            this.currentPage = 1;
        }
    },
    methods: {

        async orderProvider(ctx, callback) {
            let endPoint = `/api/v0/orders/report?${ctx.filter}&sortBy=${ctx.sortBy}&sortDesc=${ctx.sortDesc}&page=${ctx.currentPage}&limit=${ctx.perPage}&reportId=${this.reportKey}`;

            let promise = await axios.get(endPoint);
            let items = promise.data.data.data;

            let ids = items.map(a => a['Orders.id']);
            this.inViewIds = ids;

            const event = new CustomEvent('order_count', {
                detail: {
                    count: items.length
                }
            });
            event.initEvent('order_count', true, true);
            window.dispatchEvent(event);
            this.fields = promise.data.data.headers;

            this.rows = promise.data.pagination.count;
            this.perPage = promise.data.pagination.limit;

            if (promise.data.pagination.page > promise.data.pagination.pages) {
                this.currentPage = 1;
            } else {
                this.currentPage = promise.data.pagination.page;
            }

            if (!this.reportKey) {
                this.fields.push({key: 'action', label: 'Action'});
                this.fields.unshift({key: 'bulk', label: ''});
            }

            return items || []
        },
        selectAll(checked) {
            if (checked) {
                this.$emit('selectall', this.inViewIds);
            } else {
                this.$emit('selectall', []);
            }
        },
        clicked(item) {
            Vue.nextTick(() => {
                this.$emit('input', this.internallySelected)
            })
        },
        refreshTable() {
            this.$refs.ordersTable.refresh();
        },
    },
}
</script>

<style scoped>
/* Override plugins/Assan/webroot/css/style.css */
.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/Orders/Report.vue